<template>
  <pt-award-audit-detail class="pt-award-audit-detail__page" :id="id" :isManualReward="is_manual_reward"></pt-award-audit-detail>
</template>

<script>
import PtAwardAuditDetail from 'cps/new-to-old-audit/pt-award-audit/pt-award-audit-detail/withData'
export default {
  name: 'pt-award-audit-detail__view',
  components: {
    'pt-award-audit-detail': PtAwardAuditDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isManualReward: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      is_manual_reward: this.isManualReward === 'true'
    }
  }
}
</script>
